import {
  Building2,
  Users,
  ClipboardCheck,
  Star,
  CalendarDays,
  TrendingUp,
} from "lucide-react";
import { AppLayout } from "@/components/layout/AppLayout";
import { StatCard } from "@/components/shared/StatCard";
import { ErrorCard } from "@/components/shared/ErrorCard";
import { Skeleton } from "@/components/ui/skeleton";
import { RevenueChart } from "@/components/dashboard/RevenueChart";
import { TopCentresList } from "@/components/dashboard/TopCentresList";
import { SubscriptionsSummary } from "@/components/dashboard/SubscriptionsSummary";
import { useDashboardStats } from "@/hooks/useDashboard";
import { formatCurrency } from "@/utils/format";

export const DashboardPage = () => {
  const { data, isLoading, error, refetch } = useDashboardStats();

  return (
    <AppLayout title="Dashboard">
      {isLoading ? (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          {Array.from({ length: 4 }).map((_, i) => (
            <Skeleton key={i} className="h-28 rounded-card" />
          ))}
        </div>
      ) : error ? (
        <ErrorCard message={(error as Error).message} onRetry={refetch} />
      ) : (
        <>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
            <StatCard
              title="Providers"
              value={data?.totalProviders ?? data?.totalBusinesses ?? 0}
              icon={Building2}
            />
            <StatCard
              title="Customers"
              value={data?.totalCustomers ?? 0}
              icon={Users}
              variant="info"
            />
            <StatCard
              title="Pending verifications"
              value={data?.pendingVerifications ?? 0}
              icon={ClipboardCheck}
              variant="warning"
            />
            <StatCard
              title="Pending reviews"
              value={data?.pendingReviews ?? 0}
              icon={Star}
              variant="warning"
            />
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
            <StatCard
              title="Total bookings"
              value={data?.totalBookings ?? 0}
              icon={CalendarDays}
            />
            <StatCard
              title="Active bookings"
              value={data?.activeBookings ?? 0}
              icon={CalendarDays}
              variant="info"
            />
            <StatCard
              title="Completed bookings"
              value={data?.completedBookings ?? 0}
              icon={CalendarDays}
              variant="success"
            />
            <StatCard
              title="Platform revenue"
              value={formatCurrency(data?.totalRevenue ?? 0)}
              icon={TrendingUp}
              variant="success"
            />
          </div>

          <div className="mb-4">
            <RevenueChart />
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
            <TopCentresList />
            <SubscriptionsSummary />
          </div>
        </>
      )}
    </AppLayout>
  );
};

export default DashboardPage;
